import React, { useEffect } from "react"
import { Box } from "src/UILibrary"
import { useMediaQuery } from "react-responsive"
import { MEMBER_TYPE } from "src/modules/const"
import { UserProfilePage } from "./user/UserProfilePage"
import { AdminProfilePage } from "./admin/AdminProfilePage"
import { CompanyProfilePage } from "./company/CompanyProfilePage"
import { AdviserProfilePage } from "./adviser/AdviserProfilePage"
import { useLoginContext } from "src/hooks/useLoginContext"

export const ProfilePageItem = () => {
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const { initialized, userType } = useLoginContext()
  useEffect(() => {
    if (!initialized) return
  }, [initialized])

  return (
    <Box
      id="box_profile"
      sx={{
        ...(isTablet
          ? { height: "800px", pt: "40px", pl: "0px" }
          : { width: "100%", pl: "10px", position: "absolute", top: 60, bottom: 120 }),
        overflowY: "scroll",
      }}
    >
      {userType == MEMBER_TYPE.USER && <UserProfilePage />}
      {userType == MEMBER_TYPE.ADMINISTRATOR && <AdminProfilePage />}
      {userType == MEMBER_TYPE.COMPANY && <CompanyProfilePage />}
      {userType == MEMBER_TYPE.ADVISER && <AdviserProfilePage />}
    </Box>
  )
}
